import * as loginTypes from './loginTypes';
import { LOGINPAGE, LOGINSSOPAGE } from './constants';

const ssoDisabled = process.env.REACT_APP_PORTAL_SSO_ENABLED === 'false';

const initialState = {
  loginPage: ssoDisabled ? LOGINPAGE : LOGINSSOPAGE,
  userInfo: {
    personId: null,
  },
  flow: 'login',
  isAuthenticated: false,
  isValidated: false,
  numberAttempts: 0,
  userRoles: {
    applicant: false,
    corpClient: false,
    eyPro: false,
    eyAdmin: false,
  },
  userId: null,
  isRoleSelect: false,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case loginTypes.POST_LOGIN_PENDING:
    case loginTypes.POST_LOGIN_SSO_PENDING:
      return { ...state, loginStatus: loginTypes.LOGIN_STATUS.PENDING };
    case loginTypes.POST_LOGIN_SUCCESS:
    case loginTypes.POST_LOGIN_SSO_SUCCESS:
      return {
        ...state,
        loginStatus: loginTypes.LOGIN_STATUS.SUCCESS,
        ...action.data,
        isAuthenticated: true,
        flow: 'login',
        numberAttempts: 0,
        userId: window.sha256(action.data.email),
      };
    case loginTypes.POST_LOGIN_FAILURE:
    case loginTypes.POST_LOGIN_SSO_FAILURE:
      return {
        ...state,
        loginStatus: loginTypes.LOGIN_STATUS.FAILURE,
        numberAttempts: state.numberAttempts + 1,
        userSuccess: false,
        error: { ...action.error },
      };
    case loginTypes.CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        numberAttempts: 0,
        userInfo: {
          personId: null,
        },
        returnTologin: false,
      };
    case loginTypes.RETURN_TO_LOGIN:
      return { ...state, returnTologin: true };
    case loginTypes.GOTO_LOGIN_SSO:
      return { ...state, loginPage: LOGINSSOPAGE };
    case loginTypes.GOTO_LOGIN:
      return { ...state, loginPage: LOGINPAGE };
    case loginTypes.USER_VALIDATE_SUCCESS:
      const { userInfo } = action.data;
      return { ...state, userInfo };
    case loginTypes.UPDATE_USER_ROLES: {
      const { userRoles } = action;
      return { ...state, isValidated: true, userRoles };
    }
    case loginTypes.SET_USER_FROM_SESSION: {
      return { ...state, ...action.data };
    }
    case loginTypes.CLEAR_SESSION: {
      return {
        ...state,
        isAuthenticated: false,
        numberAttempts: 0,
        userInfo: {
          personId: null,
        },
      };
    }
    case loginTypes.LOGOUT_SESSION: {
      return {
        ...state,
        loginPage: state.loginPage,
      };
    }
    case loginTypes.CHANGE_ROLE_SELECTION: {
      return {
        ...state,
        isRoleSelect: action.state,
      };
    }
    default:
      return state;
  }
};

export { initialState };
export default loginReducer;
